import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { SendPasswordResetEmail } from 'domain/usecases/send-password-reset-email';
import { RemoteSendPasswordResetEmail } from 'data/usecases/send-password-reset-email';

export const makeRemoteSendPasswordResetEmail = (): SendPasswordResetEmail => {
  return new RemoteSendPasswordResetEmail(makeApiUrl('/users/passwordResetEmail'), makeAuthorizeHttpClientDecorator());
};
